import React from 'react';
import PayoutDetailsComponent from './payout-details.component';

const PayoutDetails = (props) => {
    return <PayoutDetailsComponent {...props} />;
};

export default PayoutDetails;
